import React from "react";
import Navbar from "../common/navbar";
import { IoMail } from "react-icons/io5";
import Profile from "../profile/profile";
import { FaPhoneAlt } from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";
import { ToastContainer } from "react-toastify";
import useActiveTab from "../../hooks/setActiveTab";
import ContactCard from "../profile/contact/contactCard";

const MainCard = () => {
  const { activeTab, setActiveTab, renderContent } = useActiveTab();

  return (
    <>
      <ToastContainer
        theme="dark"
        autoClose={1000}
        hideProgressBar={true}
        position="bottom-center"
        className="font-poppins text-center"
      />
      <div className="container-lg mx-auto h-full py-16 px-4 sm:px-6 lg:px-36">
        <div className="flex xl:flex-row flex-col gap-4">
          <div className="xl:w-min h-min glass-morphism p-4 xl:sticky xl:top-0">
            <Profile
              email={
                <ContactCard
                  textOne={"E-Mail"}
                  textTwo={"sukesh@uwindsor.ca"}
                  icon={<IoMail size={25} color="white" />}
                />
              }
              phone={
                <ContactCard
                  textOne={"Phone"}
                  textTwo={"+1 (437) 966-6118"}
                  icon={<FaPhoneAlt size={25} color="white" />}
                />
              }
              location={
                <ContactCard
                  textOne={"Location"}
                  textTwo={"Windsor, ON, Canada"}
                  icon={<FaMapLocation size={25} color="white" />}
                />
              }
            />
          </div>
          <div className="flex flex-col gap-4 w-full">
            <div className="glass-morphism overflow-y-auto p-4">
              <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
            <div className="glass-morphism overflow-y-auto p-4">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainCard;
